export default function Pill({ children, tone = "purple" }: any) {
    const map: any = {
        purple: "bg-purple-100 text-purple-800",
        green: "bg-green-100 text-green-800",
        blue: "bg-blue-100 text-blue-800",
        amber: "bg-amber-100 text-amber-800",
        gray: "bg-gray-100 text-gray-800",
    };
    return <span className={`inline-flex items-center gap-1 rounded-full px-2 py-1 text-xs font-semibold ${map[tone]}`}>{children}</span>;
}